/* tslint:disable */
/* eslint-disable */
/**
 * dynamic-pricing-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { Season } from '../models';
/**
 * SeasonApi - axios parameter creator
 * @export
 */
export const SeasonApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} [seasonId] 
         * @param {string} [name] 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {boolean} [overrideSeason] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        seasonCopyGet: async (seasonId?: number, name?: string, startDate?: string, endDate?: string, overrideSeason?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Season/Copy`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (seasonId !== undefined) {
                localVarQueryParameter['seasonId'] = seasonId;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }

            if (overrideSeason !== undefined) {
                localVarQueryParameter['overrideSeason'] = overrideSeason;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [seasonId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        seasonDelete: async (seasonId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Season`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (seasonId !== undefined) {
                localVarQueryParameter['seasonId'] = seasonId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [courseId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        seasonGet: async (courseId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Season`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (courseId !== undefined) {
                localVarQueryParameter['courseId'] = courseId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Season} [season] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        seasonPost: async (season?: Season, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Season`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(season, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [seasonId] 
         * @param {Season} [season] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        seasonPut: async (seasonId?: number, season?: Season, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Season`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (seasonId !== undefined) {
                localVarQueryParameter['seasonId'] = seasonId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(season, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SeasonApi - functional programming interface
 * @export
 */
export const SeasonApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SeasonApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} [seasonId] 
         * @param {string} [name] 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {boolean} [overrideSeason] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async seasonCopyGet(seasonId?: number, name?: string, startDate?: string, endDate?: string, overrideSeason?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Season>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.seasonCopyGet(seasonId, name, startDate, endDate, overrideSeason, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SeasonApi.seasonCopyGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [seasonId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async seasonDelete(seasonId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Season>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.seasonDelete(seasonId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SeasonApi.seasonDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [courseId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async seasonGet(courseId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Season>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.seasonGet(courseId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SeasonApi.seasonGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Season} [season] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async seasonPost(season?: Season, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Season>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.seasonPost(season, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SeasonApi.seasonPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [seasonId] 
         * @param {Season} [season] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async seasonPut(seasonId?: number, season?: Season, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Season>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.seasonPut(seasonId, season, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SeasonApi.seasonPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SeasonApi - factory interface
 * @export
 */
export const SeasonApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SeasonApiFp(configuration)
    return {
        /**
         * 
         * @param {number} [seasonId] 
         * @param {string} [name] 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {boolean} [overrideSeason] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        seasonCopyGet(seasonId?: number, name?: string, startDate?: string, endDate?: string, overrideSeason?: boolean, options?: any): AxiosPromise<Season> {
            return localVarFp.seasonCopyGet(seasonId, name, startDate, endDate, overrideSeason, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [seasonId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        seasonDelete(seasonId?: number, options?: any): AxiosPromise<Season> {
            return localVarFp.seasonDelete(seasonId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [courseId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        seasonGet(courseId?: number, options?: any): AxiosPromise<Array<Season>> {
            return localVarFp.seasonGet(courseId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Season} [season] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        seasonPost(season?: Season, options?: any): AxiosPromise<Season> {
            return localVarFp.seasonPost(season, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [seasonId] 
         * @param {Season} [season] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        seasonPut(seasonId?: number, season?: Season, options?: any): AxiosPromise<Season> {
            return localVarFp.seasonPut(seasonId, season, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SeasonApi - object-oriented interface
 * @export
 * @class SeasonApi
 * @extends {BaseAPI}
 */
export class SeasonApi extends BaseAPI {
    /**
     * 
     * @param {number} [seasonId] 
     * @param {string} [name] 
     * @param {string} [startDate] 
     * @param {string} [endDate] 
     * @param {boolean} [overrideSeason] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SeasonApi
     */
    public seasonCopyGet(seasonId?: number, name?: string, startDate?: string, endDate?: string, overrideSeason?: boolean, options?: RawAxiosRequestConfig) {
        return SeasonApiFp(this.configuration).seasonCopyGet(seasonId, name, startDate, endDate, overrideSeason, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [seasonId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SeasonApi
     */
    public seasonDelete(seasonId?: number, options?: RawAxiosRequestConfig) {
        return SeasonApiFp(this.configuration).seasonDelete(seasonId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [courseId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SeasonApi
     */
    public seasonGet(courseId?: number, options?: RawAxiosRequestConfig) {
        return SeasonApiFp(this.configuration).seasonGet(courseId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Season} [season] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SeasonApi
     */
    public seasonPost(season?: Season, options?: RawAxiosRequestConfig) {
        return SeasonApiFp(this.configuration).seasonPost(season, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [seasonId] 
     * @param {Season} [season] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SeasonApi
     */
    public seasonPut(seasonId?: number, season?: Season, options?: RawAxiosRequestConfig) {
        return SeasonApiFp(this.configuration).seasonPut(seasonId, season, options).then((request) => request(this.axios, this.basePath));
    }
}

